import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function VacancyList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false },
        { key: "title", sortable: true },
        { key: "experience", sortable: true },
        { key: "status", sortable: true, label: "Status" },
        {
            key: "urgency_status_label",
            sortable: true,
            label: "Urgency Status"
        },
        { key: "type", sortable: true, label: "Type" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalVacancyList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const filterByVacancyUrgencyStatus = ref(null);
    const filterByVacancyType = ref(null);
    const vacanciesMetaData = ref([]);
    const vacancyStatusOption = ref([]);
    const vacancyUrgencyStatusOption = ref([]);
    const vacancyTypeOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalVacancyList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [
            currentPage,
            perPage,
            searchQuery,
            statusFilter,
            filterByVacancyUrgencyStatus,
            filterByVacancyType,
        ],
        () => {
            refetchData();
        }
    );

    const fetchVacancyList = (ctx, callback) => {
        store
            .dispatch("app-vacancies/fetchVacancies", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
                urgency_status: filterByVacancyUrgencyStatus.value,
                type: filterByVacancyType.value,
            })
            .then(response => {
                const vacancies = response.data.data;
                const { total } = response.data.meta;
                vacancyStatusOption.value = response.data.status;
                vacancyUrgencyStatusOption.value = response.data.urgency_status;
                vacancyTypeOption.value = response.data.type;

                callback(vacancies);
                totalVacancyList.value = total;
                vacanciesMetaData.value = vacancies;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching vacancies",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });
                this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching vacancies`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == false) return "danger";
        if (status == true) return "success";
        return "primary";
    };

    return {
        fetchVacancyList,
        tableColumns,
        perPage,
        currentPage,
        totalVacancyList,
        vacanciesMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        statusFilter,
        filterByVacancyUrgencyStatus,
        filterByVacancyType,
        vacancyStatusOption,
        vacancyUrgencyStatusOption,
        vacancyTypeOption,
        resolveUserStatusVariant
    };
}
